import { i18n } from "../../i18n/i18n";

import React, { Component, RefObject } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Transformer as HTMLTransformerElement } from 'konva/lib/shapes/Transformer'
import { RootState } from '../../store'
import {
  resetState,
  replaceId,
  replaceMarkup,
  replaceActive,
  resetElements,
  clearSelectedElement,
  replaceCloning,
  Markup,
  ImageElement
} from '../../views/LabelBuilder/LabelBuilder.slice'
import labelApi, {
  LabelCreateRequest,
  LabelSnapshotRequest,
  LabelUpdateRequest
} from '../../apis/label.api'
import { ConfirmParams } from '../Confirm/Confirm.state'
import confirmService from '../../services/confirm.service'
import printService from '../../services/print.service'
import Button from '../Button'
import Card from '../Card'


import html2canvas from 'html2canvas';
import { first } from 'lodash'
import { Promise } from 'bluebird'
import markupService from '../../services/markup.service'
import unitUtil from '../../utils/unit.util'
import { jsPDF } from "jspdf";
import storageService from '../../services/storage.service'
import { isLabeledStatement } from 'typescript'
import routes from '../../routes/routes'
import logoIcon from '../../assets/waterMark.png'
import { nanoid } from "nanoid";

interface RouteState {
  customLabelId?: number
  systemLabelId?: number
}

interface Props {
  transformerRef: RefObject<HTMLTransformerElement>
}

type CombinedProps = Props
  & RouteComponentProps<any, any, RouteState>
  & ConnectedProps<typeof connector>

interface DownloadOption {
    label: string;
    value: 'png' | 'jpeg' | 'svg' | 'eps' | 'zpl' | 'pdf';
  }  

const downloadOptions: DownloadOption[] = [
  { label: 'PNG', value: 'png' },
  { label: 'JPEG', value: 'jpeg' },
  { label: 'SVG', value: 'svg' },
  { label: 'EPS', value: 'eps' },
  { label: 'ZPL', value: 'zpl' },
  { label: 'PDF', value: 'pdf' },
];

interface State {
  showPopup: boolean;
  showTrialAlert: boolean;
}

class Actions extends Component<CombinedProps, State> {
  constructor (props: CombinedProps) {
    super(props)

    this.state = {
      showPopup: false,
      showTrialAlert: false,
    };

    this.handlePreviewClick = this.handlePreviewClick.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
    this.handleActivateClick = this.handleActivateClick.bind(this)
    this.handleDownloadLabel = this.handleDownloadLabel.bind(this)
    this.togglePopup = this.togglePopup.bind(this)
    this.toggleTrialAlertPopup = this.toggleTrialAlertPopup.bind(this)
    this.handleCancelTrialAlert = this.handleCancelTrialAlert.bind(this)
    this.handleSubscribeClick = this.handleSubscribeClick.bind(this)
  }

  get cancelButton () {
    const { state } = this.props.location
    if (!state) return
    const { customLabelId } = state
    return customLabelId &&
      <Button
        type='secondary'
        text={i18n("Cancel")}
        onClick={this.handleCancelClick} />
  }

  handleCancelClick = () => {
    this.props.history.goBack()
  }

  handleDeleteLabelConfirm (id: number) {
    labelApi.delete(id, label => {
      if (!label) return
      this.props.resetState()
    })
  }

  handleDeleteLabelClick = () => {
    const { id } = this.props
    if (!id) return
    const confirm: ConfirmParams = {
      id,
      type: 'warning',
      question: i18n('Are you sure to delete the label?'),
      confirmText: i18n('Yes'),
      cancelText: i18n('No'),
      onConfirm: () => this.handleDeleteLabelConfirm(id)
    }
    confirmService.push(confirm)
  }

  convertImageToBase64 = (src: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // necessary for local/hosted images
      img.src = src;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(new Error('Could not get canvas context'));

        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = reject;
    });
  }

  // BR
  createWatermarkElement(base64: string, pos: string): ImageElement {
    let canvasWidth = Number(localStorage.getItem("canvasWidth"));
    let canvasHeight = Number(localStorage.getItem("canvasHeight"));

    let canvasWidthX = 0
    let canvasHeightX = 0

    const unit = localStorage.getItem("canvasUnit");

    const MM_TO_PX = 96 / 25.4;
    const IN_TO_PX = 96;

    if (unit === 'mm') {
      canvasWidthX = canvasWidth * MM_TO_PX;
      canvasHeightX = canvasHeight * MM_TO_PX;
    } else if (unit === 'in') {
      canvasWidthX = canvasWidth * IN_TO_PX;
      canvasHeightX = canvasHeight * IN_TO_PX;
    }

    // Scale image down (e.g., 30% of canvas) and center it
    const rawWatermarkWidth = canvasWidthX * 0.5; // actual image size
    const rawWatermarkHeight = canvasHeightX * 0.5;

    const w = 30
    const h = 30

    var x = 0
    var y = 0

    //TR
    if(pos == "TR"){
     x = (canvasWidthX) -w;
     y = 0;
    }

    //BR
    else if(pos == "BR"){
     x = (canvasWidthX) -w;
     y = (canvasHeightX)-h;
    }

    //BL
    else if(pos == "BL"){
     x = 0
     y = (canvasHeightX)-h;
    }

    //TL
    else if(pos == "TL") {
     x = 0;
     y = 0;
    }

    //CR
    else {
      x = (canvasWidthX -w)/2;
     y = (canvasHeightX-h)/2;
    }

    console.log("Original size: W: "+canvasWidth+", H:"+canvasHeight+", U: "+unit);
    console.log("Converted size: W: "+canvasWidthX+", H:"+canvasHeightX+", U: px");
    console.log("Position: ("+x+","+y+")")

    const watermark: ImageElement = {
      id: nanoid(),
      type: "image",
      url: base64,
      width: w,   // full size (before scale)
      height: h,
      scaleX: 1,
      scaleY: 1,
      x: x,
      y: y,
      rotation: 0,
      opacity: 0.4, // optional: watermark-like transparency
    };

    return watermark;
  }

  handlePreviewClick = async () => {
    const payload = { markup: this.props.markup };

    labelApi.preview(payload, async (markup) => {
      if (!markup) return;

      if(storageService.get("inTrial") == true && storageService.get("isLabelBuilder") == true) {
        const base64 = await this.convertImageToBase64(logoIcon);
        const watermark = this.createWatermarkElement(base64,"TL")
        const watermark2 = this.createWatermarkElement(base64,"TR")
        const watermark3 = this.createWatermarkElement(base64,"BL")
        const watermark4 = this.createWatermarkElement(base64,"BR")
        const watermark5 = this.createWatermarkElement(base64,"CR")
        //console.log(JSON.stringify(markup))

        markup.elements = [
          ...markup.elements.filter(el => el.id !== 'watermark'),
          watermark,watermark2,watermark3,watermark4,watermark5
        ];

      
      }

      printService.printMarkups([markup]);
    });
  }

  create (active: boolean) {
    const { markup } = this.props
    const payload: LabelCreateRequest = { active, markup }
    labelApi.create(payload, label => {
      if (!label) return
      const { id, markup, active } = label
      this.props.replaceId(id)
      this.props.replaceMarkup(markup)
      this.props.replaceActive(active)

      this.createSnapshotImageAndUpload(markup, id)
    })
  }

  async htmlToCanvas(element: HTMLElement) {
    if (element) {
      const canvas = await html2canvas(element);
      const image = canvas.toDataURL('image/png');
      return image
    }
    return null
  }

  async createSnapshotImageAndUpload(markup: Markup, id: number){
    const mainElement = document.createElement('div')
    const labelElement = document.createElement('div')
    const imageElement = await markupService.toImageElement(markup)
    if (!imageElement) return
    imageElement.style.width = 'calc(100% - 1px)'
    imageElement.style.height = 'calc(100% - 1px)'
    labelElement.appendChild(imageElement)
    mainElement.appendChild(labelElement)
    
    document.documentElement.appendChild(mainElement)
    var imageData = await this.htmlToCanvas(mainElement)
    mainElement.remove();
    if(imageData){
      var payload: LabelSnapshotRequest = { image: imageData, id: id  }
      labelApi.saveLabelSnapshot(payload, resp => {
        console.log("Snapshot API successful")
      })

    }
  }

  togglePopup = () => {
    this.setState((prevState) => ({ showPopup: !prevState.showPopup }));
  };

  toggleTrialAlertPopup = () => {
    this.setState((prevState) => ({ showTrialAlert: !prevState.showTrialAlert }));
  };

  downloadLabel (format: string) {
    const { markup } = this.props
    switch(format){
      case 'png':
        this.createSnapshotImageAndDownload(markup, 1, 'png')
        break
      case 'jpeg':
        this.createSnapshotImageAndDownload(markup, 1, 'jpeg')
        break  
      case 'svg':
        this.createSnapshotImageAndDownload(markup, 1, 'svg')
        break    
      case 'eps':
        this.createSnapshotImageAndDownload(markup, 1, 'eps')
        break   
      case 'zpl':
        this.createSnapshotImageAndDownload(markup, 1, 'zpl')
        break 
      case 'pdf':
        this.createSnapshotImageAndDownload(markup, 1, 'pdf')
        break      
      default:
        break
    }
  }

  // Start download funcionality
  async createSnapshotImageAndDownload(markup: Markup, id: number, format: 'png' | 'jpeg' | 'svg' | 'eps' | 'zpl' | 'pdf' = 'png') {
    const mainElement = document.createElement('div');
    const labelElement = document.createElement('div');
    const imageElement = await markupService.toImageElement(markup);
  
    if (!imageElement) return;
  
    imageElement.style.width = 'calc(100% - 1px)';
    imageElement.style.height = 'calc(100% - 1px)';
    labelElement.appendChild(imageElement);
    mainElement.appendChild(labelElement);
  
    document.documentElement.appendChild(mainElement);
  
    if (format === 'pdf') {
      const canvas = await html2canvas(mainElement, { scale: 1 }); 
      mainElement.remove();
    
      if (canvas) {
        const dpi = 203; 
        
        let widthInches = Number(localStorage.getItem("canvasWidth"));
        let heightInches = Number(localStorage.getItem("canvasHeight"));
        let unit = localStorage.getItem("canvasUnit");
    
        if (unit === 'mm') {
          widthInches /= 25.4;
          heightInches /= 25.4;
        } else if (unit === 'px') {
          widthInches /= dpi;
          heightInches /= dpi;
        }
    
        const pdfWidth = widthInches * 72;
        const pdfHeight = heightInches * 72;
    
        const imageData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
          unit: 'pt',
          format: [pdfWidth, pdfHeight],
        });
    
        pdf.addImage(imageData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`snapshot_${id}.pdf`);
      }
    }
    
    else if (format === 'zpl') {
      var u =localStorage.getItem("canvasUnit");
      var w = Number(localStorage.getItem("canvasWidth"));
      var h = Number(localStorage.getItem("canvasHeight"));
      
      //if(u ==  'in'){}
      if(u ==  'mm'){
        w = w / 25.4;
        h = h / 25.4;
      }
      if(u ==  'px'){
        w = w / 203;
        h = h / 203;
      }

      const zplData = await this.convertToZPLUsingAPI(mainElement,w,h);
      if (zplData) {
          const blob = new Blob([zplData], { type: 'text/plain;charset=utf-8' });
          this.downloadFile(blob, `snapshot_${id}.zpl`);
      }
    }  
    
    else if (format === 'svg' || format === 'eps') {
      
     const canvas = await html2canvas(mainElement, { backgroundColor: null }); 
     mainElement.remove();
     
     if (canvas) {
       const dpi = 96; 

       let widthInches = Number(localStorage.getItem("canvasWidth"));
       let heightInches = Number(localStorage.getItem("canvasHeight"));
       let unit = localStorage.getItem("canvasUnit");
   
       if (unit === 'mm') {
         widthInches /= 25.4;
         heightInches /= 25.4;
       } else if (unit === 'px') {
         widthInches /= dpi;
         heightInches /= dpi;
       }
   
       const svgWidth = widthInches * dpi;
       const svgHeight = heightInches * dpi;
       
       const imageData = canvas.toDataURL("image/png");
       
       const svg = `<?xml version="1.0" encoding="UTF-8"?>
       <svg xmlns="http://www.w3.org/2000/svg" width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
         <image href="${imageData}" width="${svgWidth}" height="${svgHeight}"/>
       </svg>`;
       
       const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
 
       if (format === 'svg') {
         this.downloadFile(blob, `snapshot_${id}.svg`);
       } else {
         const epsData = `!PS-Adobe-3.0 EPSF-3.0\n${svg}`;
         const epsBlob = new Blob([epsData], { type: 'application/postscript' });
         this.downloadFile(epsBlob, `snapshot_${id}.eps`);
       }
     }


    } 
    
    else {
      const canvas = await html2canvas(mainElement);
      mainElement.remove();
  
      if (canvas) {
        const imageData =
          format === 'jpeg'
            ? canvas.toDataURL('image/jpeg', 0.9)
            : canvas.toDataURL('image/png');
  
        const blob = this.dataURLToBlob(imageData);
        const fileExtension = format === 'jpeg' ? 'jpg' : 'png';
        this.downloadFile(blob, `snapshot_${id}.${fileExtension}`);
      }
    }
  }

  //new
  async convertToZPLUsingAPI(element: HTMLElement, widthInInches: number = 4, heightInInches: number = 6): Promise<string> {
    const canvas = await html2canvas(element, { backgroundColor: null });

    if (!canvas) {
        throw new Error('Failed to generate canvas from element');
    }

    const maxSize = 200 * 1024; // 200 KB in bytes
    const maxPixels = 2000; // Maximum pixel dimension
    const dpi = 203; // Fixed DPI (dots per inch)

    // Convert inches to pixels
    const targetWidth = widthInInches * dpi;
    const targetHeight = heightInInches * dpi;

    // Compute scaling ratio to fit within specified dimensions while preserving aspect ratio
    const scaleX = targetWidth / canvas.width;
    const scaleY = targetHeight / canvas.height;
    const scale = Math.min(scaleX, scaleY, 1); // Prevent upscaling

    const resizedCanvas = document.createElement('canvas');
    resizedCanvas.width = Math.floor(canvas.width * scale);
    resizedCanvas.height = Math.floor(canvas.height * scale);

    const ctx = resizedCanvas.getContext('2d');
    if (!ctx) {
        throw new Error('Failed to get 2D context for resized canvas');
    }

    ctx.drawImage(canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);

    let imageData = resizedCanvas.toDataURL('image/png');
    let blob = this.dataURLToBlob(imageData);

    let compressionRatio = 1;
    while (blob.size > maxSize && compressionRatio > 0.1) {
        compressionRatio -= 0.1; 
        imageData = resizedCanvas.toDataURL('image/jpeg', compressionRatio); 
        blob = this.dataURLToBlob(imageData);
    }

    if (blob.size > maxSize) {
        throw new Error('Image could not be compressed below size limit');
    }

    const formData = new FormData();
    formData.append('file', blob, 'image.jpg');

    const response = await fetch('https://api.labelary.com/v1/graphics', {
        method: 'POST',
        headers: {
            Accept: 'application/zpl',
        },
        body: formData,
    });
  
    if (!response.ok) {
        throw new Error(`Failed to convert image to ZPL: ${response.statusText}`);
    }

    const zplData = await response.text();
    return zplData;
}
  
  dataURLToBlob(dataURL: string): Blob {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const arrayBuffer = new Uint8Array(byteString.length);
  
    for (let i = 0; i < byteString.length; i++) {
      arrayBuffer[i] = byteString.charCodeAt(i);
    }
  
    return new Blob([arrayBuffer], { type: mimeString });
  }
  
  downloadFile(blob: Blob, filename: string) {
    const downloadLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
  
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  
    URL.revokeObjectURL(url);
  }
  // End download functionality
  
  update (id: number, active: boolean) {
    const { markup } = this.props
    const payload: LabelUpdateRequest = { id, active, markup }
    labelApi.update(id, payload, label => {
      if (!label) return
      const { markup, active } = label
      this.props.replaceMarkup(markup)
      this.props.replaceActive(active)

      this.createSnapshotImageAndUpload(markup, id)
    })
  }

  handleSaveClick () {
    const { id, markup } = this.props
    const active = false
    if (id) this.update(id, active)
    else this.create(active)
  }

  handleDownloadLabel (format: string) {
    this.togglePopup(); 

    if(storageService.get("inTrial") == true) {
      this.toggleTrialAlertPopup();
      return
    }

    const { id, markup } = this.props
    console.log("Downloading PNG...."+JSON.stringify(markup))
    this.downloadLabel(format)
  }

  handleCancelTrialAlert() {
    this.toggleTrialAlertPopup()
  }

  handleSubscribeClick() {
    this.toggleTrialAlertPopup()
    this.props.history.push(routes.userSubscriptions)
  }

  handleActivateClick () {
    const { id } = this.props
    const active = true
    if (id) this.update(id, active)
    else this.create(active)
  }

  handleClearElementsClick = () => {
    const confirm: ConfirmParams = {
      id: 0,
      type: 'warning',
      question: i18n('Are you sure to clear all elements?'),
      confirmText: i18n('Yes'),
      cancelText: i18n('No'),
      onConfirm: () => this.props.resetElements()
    }
    confirmService.push(confirm)
  }

  handleClearElementConfirm = () => {
    this.props.clearSelectedElement()
    const transformerNode = this.props.transformerRef.current
    if (!transformerNode) return
    transformerNode.nodes([])
  }

  handleClearElementClick = () => {
    const confirm: ConfirmParams = {
      id: 0,
      type: 'warning',
      question: i18n('Are you sure to clear the element?'),
      confirmText: i18n('Yes'),
      cancelText: i18n('No'),
      onConfirm: () => this.handleClearElementConfirm()
    }
    confirmService.push(confirm)
  }

  handleCloneLabelClick = () => {
    this.props.replaceCloning(true)
  }

  render () {
    const { showPopup, showTrialAlert } = this.state;

    return (
      <Card background="white" flat={true}>
        <div className='flex flex-wrap justify-end gap-2'>
          {this.props.selectedElement && <Button
            type='secondary'
            text={i18n("Clear element")}
            onClick={this.handleClearElementClick} />}
          {!this.props.selectedElement &&
            <div className='flex flex-wrap justify-end gap-2'>
              <Button
                type='danger'
                text={i18n("Delete label")}
                onClick={this.handleDeleteLabelClick} />
                <Button
                  type='secondary'
                  text={i18n("Clear elements")}
                  onClick={this.handleClearElementsClick} />
                <Button
                  type='secondary'
                  text={i18n("Preview")}
                  onClick={this.handlePreviewClick} />
                <Button
                  type='secondary'
                  text={i18n("Save draft")}
                  onClick={this.handleSaveClick} />
                <Button
                  text={i18n("Save and activate")}
                  onClick={this.handleActivateClick} />
                <Button
                  type='secondary'
                  text={i18n("Clone label")}
                  onClick={this.handleCloneLabelClick} />
                <Button
                  type="secondary"
                  text={i18n("Download")}
                  onClick={this.togglePopup}
                />      

          {showPopup && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40"
              onClick={this.togglePopup}
            ></div>

            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg w-80 p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Choose Format
                </h3>
                <ul className="space-y-2">
                  {downloadOptions.map((option) => (
                    <li key={option.value}>
                      <button
                        className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
                        onClick={() => this.handleDownloadLabel(option.value)}
                      >
                        {option.label}
                      </button>
                    </li>
                  ))}
                </ul>
                <button
                  className="mt-4 w-full bg-gray-300 text-gray-700 py-2 rounded-md hover:bg-gray-400"
                  onClick={this.togglePopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        )}

        {showTrialAlert && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-40"
              onClick={this.handleCancelTrialAlert}
            ></div>
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg w-80 p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Subscription Required
                </h3>
                <p className="text-sm text-gray-600 mb-4">{i18n("To download this format, you need a paid subscription.")}</p>
                <div className="flex gap-2">
                  <button
                    className="bg-blue-600 text-white px-4 py-2 rounded-md"
                    onClick={this.handleSubscribeClick}
                  >
                    Subscribe
                  </button>
                  <button
                    className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md"
                    onClick={this.handleCancelTrialAlert}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </>
        )}




                {this.cancelButton}
            </div>
          }
        </div>
      </Card>
    )
  }
}

function mapStateToProps (state: RootState) {
  const labelBuilderState = state.labelBuilder
  const { markup, id } = labelBuilderState
  const { selectedElement } = markup
  return {
    markup,
    selectedElement,
    id
  }
}

const mapDispatchToProps = {
  resetState,
  resetElements,
  replaceId,
  replaceMarkup,
  clearSelectedElement,
  replaceActive,
  replaceCloning
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(Actions))
